<script setup lang="ts">
import QuantumAquarium from '../components/QuantumAquarium.vue'
import { ref } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()
const showGuide = ref(false)

const toggleGuide = () => {
  showGuide.value = !showGuide.value
}

const navigateToGame = (game: string) => {
  if (game === 'quantum') {
    router.push('/quantum')
  } else if (game === 'toilet') {
    router.push('/toilet-feeder')
  }
}
</script>

<template>
  <main>
    <div class="game-selection">
      <h1 class="title">游戏选择</h1>

      <div class="game-cards">
        <div class="game-card" @click="navigateToGame('quantum')">
          <div class="game-preview quantum-preview">
            <QuantumAquarium class="preview-content" />
          </div>
          <div class="game-info">
            <h2>量子饲料实验室</h2>
            <p>探索量子生物的奇妙变异</p>
          </div>
        </div>

        <div class="game-card" @click="navigateToGame('toilet')">
          <div class="game-preview toilet-preview">
            <div class="preview-content toilet-content">
              <div class="toilet-icon">🚽</div>
              <div class="toilet-effects">
                <div class="effect-bubble">🐟</div>
                <div class="effect-bubble">💩</div>
                <div class="effect-bubble">📺</div>
              </div>
            </div>
          </div>
          <div class="game-info">
            <h2>马桶饲主</h2>
            <p>向异次元深渊投喂奇怪物品</p>
            <span class="new-tag">新游戏</span>
          </div>
        </div>
      </div>
    </div>

    <div class="quantum-guide">
      <button class="guide-toggle" @click="toggleGuide">?</button>
      <div class="guide-content" v-show="showGuide">
        <h3>量子饲料实验室 - 操作指南</h3>
        <ul>
          <li>点击水族箱中的任意位置投放量子饲料</li>
          <li>不同颜色的饲料有不同属性（标准、反重力、超导体、黑洞）</li>
          <li>当量子鱼吃下饲料后会发生变异，增加器官或改变外形</li>
          <li>变异等级高的鱼有机会繁殖产生新鱼</li>
          <li>混沌量表满格时会触发全屏量子震动</li>
          <li>尝试解锁隐藏成就以体验特殊效果</li>
        </ul>
        <div class="credit">量子实验室 v1.0</div>
      </div>
    </div>
  </main>
</template>

<style scoped>
main {
  width: 100vw;
  margin: 0;
  padding: 0;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-x: hidden;
  box-sizing: border-box;
  background: linear-gradient(to bottom, #0a0a20, #060620);
  padding-top: 50px;
}

.game-selection {
  width: 90%;
  max-width: 1200px;
}

.title {
  color: white;
  text-align: center;
  font-size: 2.5rem;
  margin-bottom: 50px;
  text-shadow: 0 0 10px rgba(255, 255, 255, 0.5);
}

.game-cards {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 30px;
}

.game-card {
  width: 350px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 15px;
  overflow: hidden;
  transition: all 0.3s ease;
  cursor: pointer;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.game-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
  background: rgba(255, 255, 255, 0.1);
}

.game-preview {
  height: 200px;
  position: relative;
  overflow: hidden;
}

.preview-content {
  width: 100%;
  height: 100%;
}

.toilet-preview {
  background: linear-gradient(to bottom, #000430, #000028);
}

.toilet-content {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.toilet-icon {
  font-size: 80px;
  animation: bounce 2s infinite;
}

.effect-bubble {
  position: absolute;
  font-size: 24px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: float 3s infinite;
}

.effect-bubble:nth-child(1) {
  top: 30px;
  right: 70px;
  animation-delay: 0s;
}

.effect-bubble:nth-child(2) {
  bottom: 40px;
  left: 70px;
  animation-delay: 0.5s;
}

.effect-bubble:nth-child(3) {
  top: 50%;
  right: 30%;
  animation-delay: 1s;
}

.game-info {
  padding: 20px;
  position: relative;
}

.game-info h2 {
  color: white;
  margin: 0 0 10px 0;
}

.game-info p {
  color: rgba(255, 255, 255, 0.7);
  margin: 0;
}

.new-tag {
  position: absolute;
  top: 20px;
  right: 20px;
  background: #ff4fff;
  color: white;
  padding: 3px 8px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: bold;
}

.quantum-guide {
  position: fixed;
  bottom: 20px;
  left: 20px;
  z-index: 1000;
}

.guide-toggle {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  font-size: 18px;
  font-weight: bold;
  border: 2px solid rgba(255, 255, 255, 0.3);
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.guide-toggle:hover {
  background: rgba(0, 0, 0, 0.7);
  transform: scale(1.1);
}

.guide-content {
  position: absolute;
  bottom: 50px;
  left: 0;
  width: 300px;
  background: rgba(0, 0, 0, 0.8);
  color: white;
  border-radius: 10px;
  padding: 15px;
  font-size: 14px;
  backdrop-filter: blur(5px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  animation: fadeIn 0.3s ease;
}

.guide-content h3 {
  margin-top: 0;
  color: var(--accent-color, #ff4fff);
  font-size: 16px;
}

.guide-content ul {
  margin: 10px 0;
  padding-left: 20px;
}

.guide-content li {
  margin-bottom: 8px;
  line-height: 1.4;
}

.credit {
  font-size: 12px;
  text-align: right;
  opacity: 0.6;
  margin-top: 10px;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes bounce {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

@keyframes float {
  0%,
  100% {
    transform: translate(0, 0);
  }
  25% {
    transform: translate(5px, -5px);
  }
  50% {
    transform: translate(10px, 0);
  }
  75% {
    transform: translate(5px, 5px);
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .game-cards {
    flex-direction: column;
    align-items: center;
  }

  .game-card {
    width: 90%;
  }
}
</style>
